// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__62p3-","right":"Footer_right__36Gom","buttons":"Footer_buttons__1iYcK"};